/**
 * @desc 获取供应商SN码操作记录
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<Array<defs.srm.SupplierSnOperateResponseDto>>;
export function request(snno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierSnOperateRecord/getRecordList/${snno}`, {
      method: "GET",

      ...options,
    }),
  );
}
